import { render, staticRenderFns } from "./GroupMasterLayout.vue?vue&type=template&id=6d56ecb2&scoped=true&"
import script from "./GroupMasterLayout.vue?vue&type=script&lang=js&"
export * from "./GroupMasterLayout.vue?vue&type=script&lang=js&"
import style0 from "./GroupMasterLayout.vue?vue&type=style&index=0&id=6d56ecb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56ecb2",
  null
  
)

export default component.exports